import { render, staticRenderFns } from "./CreateMerchant.vue?vue&type=template&id=cc84dbac&"
import script from "./CreateMerchant.vue?vue&type=script&lang=js&"
export * from "./CreateMerchant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports